import React, { useEffect, useState } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import LoadMask from "Utils/LoadMask/LoadMask";
import { PacasAlCorteApi } from "../api/PacasAlCorteApi";
import { PacasAlCorteTable } from "./PacasAlCorteTable";
import { PacasCierreCerradoTable } from "./PacasCierreCerradoTable";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";

export const PacasAlCorteContenido = ({ consulta, regresar }) => {
    const { getPacasAlCorte, cargando } = PacasAlCorteApi();

    const [datos, setDatos] = useState(null);

    const GetPacasAlCorte = async () => {
        try {
            const response = await getPacasAlCorte(consulta);
            setDatos(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las pacas por pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setDatos(null);
        }
    };

    useEffect(() => {
        GetPacasAlCorte();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadMask loading={cargando} blur>
            {datos && (
                <React.Fragment>
                    <div className="mb-3">
                        <p className="mb-1 help-text-2">
                            Pacas por pallet de <b>{datos.producto_nombre}</b>,{" "}
                            {datos.es_conforme_bodega
                                ? "conforme"
                                : "no conforme"}
                            , al{" "}
                            {moment(datos.fecha_corte).format(
                                "DD/MM/YYYY HH:mm",
                            )}
                            {datos.numero
                                ? ` (cierre ${datos.numero}).`
                                : "."}
                        </p>
                        <p className="mb-0 help-text-2">
                            {datos.numero
                                ? "Los pallets reajustados en el cierre muestran las pacas registradas antes del conteo y las pacas reales que se contaron."
                                : "La fecha de corte es anterior al último movimiento de bodega, por lo que las pacas corresponden a lo registrado hasta ese momento y no admiten reajustes."}
                        </p>
                    </div>

                    {/* solo un cierre cerrado puede tener reajustes; el
                    cierre en proceso llega aquí con un corte que no los
                    admite */}
                    {datos.numero ? (
                        <PacasCierreCerradoTable lineas={datos.lineas} />
                    ) : (
                        <PacasAlCorteTable lineas={datos.lineas} />
                    )}
                </React.Fragment>
            )}

            <div className="d-flex justify-content-center mt-5 gap-1rem">
                <button className="btn btn-primary" onClick={regresar}>
                    Regresar
                </button>
            </div>
        </LoadMask>
    );
};
